// @flow

import { Platform } from 'react-native';

export default class FontService {
  static getFontWeight(fontWeight: ?string, fontFamily: string): string {
    if (!fontWeight && fontFamily === 'Gotham') {
      return 'book';
    } else if (!fontWeight) {
      return '';
    }

    const map = {
      Gotham: {
        bold: 'bold',
        normal: 'book',
        '100': 'light',
        '200': 'light',
        '300': 'light',
        '500': 'medium',
        '600': 'medium',
        '700': 'bold',
        '800': 'bold',
        '900': 'bold',
        '400': 'book',
      },
      Lato: {
        bold: 'bold',
        normal: '',
        '100': 'light',
        '200': 'light',
        '300': 'light',
        '500': 'bold',
        '600': 'bold',
        '700': 'bold',
        '800': 'bold',
        '900': 'bold',
        '400': '',
      },
    };

    if (!map[fontFamily]) return '';

    return map[fontFamily][fontWeight];
  }

  static getFontModifier(fontWeight: ?string, fontFamily: string, italic: boolean = false): string {
    return italic ? 'italic' : FontService.getFontWeight(fontWeight, fontFamily);
  }

  static getStyle = (fontFamily: string, fontWeight: ?string, italic: boolean | string = false): any => {
    const isItalic = italic === true || italic === 'italic';
    return Platform.select({
      ios: {
        fontFamily,
        fontWeight,
        fontStyle: isItalic ? 'italic' : 'normal',
      },
      android: {
        fontFamily: [fontFamily, FontService.getFontModifier(fontWeight, fontFamily, isItalic)].filter(Boolean).join('_'),
        fontWeight: undefined,
      },
    });
  }
}
